import script from "./UserSignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSignUp.vue?vue&type=script&setup=true&lang=js"

import "./UserSignUp.vue?vue&type=style&index=0&id=03b11011&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b11011"]])

export default __exports__